@if (((newsResource.value()?.newsArticles) ?? []).length > 0) {
<div mat-content style="color: #204b78;">
  <mat-card class="news-next">
    <mat-card-title class="top-title">
      <span>Aktuelle Nachrichten</span>
      <!-- <button mat-icon-button><mat-icon class="material-icons-outlined">info</mat-icon></button>  -->
    </mat-card-title>
    @for (newsItem of (newsResource.value()?.newsArticles); track newsItem.xid; let isLast = $last) {
    <mat-card-title>
      {{newsItem.tsPublished | date : 'longDate'}}
    </mat-card-title>
    <mat-card-content>
      @if (newsItem.subject) {
      <div class="news-title">{{newsItem.subject}}</div>
      }
      <div class="ystm-dialog-theme">
        <markdown [data]="newsItem.content" />
      </div>
      <!-- <div>{{newsItem.content}}</div> -->
      @if (newsItem.url) {
      <a matButton [href]="newsItem.url" target="_blank">{{newsItem.url}}</a>
      }
    </mat-card-content>
    @if (!isLast) {
    <mat-divider></mat-divider>
    }
    }
  </mat-card>
</div>
}